<table *ngIf="signatureReport.length" class="layout-fixed">
  <colgroup>
    <col class="width-100" />
  </colgroup>
  <thead>
    <tr>
      <th>
        <h3 i18n="@@report.reportPrintSignatures.titleSignatures">Signatures</h3>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="text-center">
        <h4 class="signature" *ngFor="let item of signatureReport">
          <span class="name">{{item.name}}</span>
          {{item.approver}}
        </h4>
      </td>
    </tr>
  </tbody>
</table>
